<template>
    <div>
    <textarea class="form-control" v-model="handler" @change="change" rows="10"></textarea>
    </div>


</template>
<script>



export default {
  props: ['config', 'name', 'value'],
  data(){
      return {
          handler:'',
      }
  },
  mounted(){
      var text = this.value;
        this.handler = text;
  },
  methods:{
    change(){
        var text = this.handler;
        this.$emit('change',text);
    },
  }

}
</script>
